import { collectCriticalAssetUrls } from './collectCriticalAssetUrls';
import { preloadImages, type PreloadImagesOptions } from './preloadImages';

export type PreloadCriticalAssetsOptions = PreloadImagesOptions;

export async function preloadCriticalAssets(
  options: PreloadCriticalAssetsOptions = {},
) {
  if (process.env.NODE_ENV === 'test') {
    options.onProgress?.(0, 0);
    return { loaded: 0, total: 0, failedUrls: [] };
  }
  const urls = collectCriticalAssetUrls();
  return preloadImages(urls, {
    concurrency: options.concurrency ?? 8,
    onProgress: options.onProgress,
  });
}

/** @deprecated Use {@link preloadCriticalAssets}. */
export async function preloadBootstrapAssets(
  options: PreloadCriticalAssetsOptions = {},
) {
  return preloadCriticalAssets(options);
}
